const scheduleContact = {
    scheduleContact: {
        pageTitle: '스케줄 예약',
        pageDescription: '위성 및 교신 스케줄을 조회하고 예약할 수 있습니다.',
        alertMessage: '정확한 교신을 위해 교신 직전에 최신 TLE로 업데이트하는 것을 권장드립니다.',
        button: {
          search: '검색'
        },
        checkout: {
          plan: '플랜',
          price: '가격',
          discount: '할인',
          selected: '개 선택됨',
          total: '총합',
          checkout: '결제하기'
        }
    }
}

export default scheduleContact;
